import React from "react";
import styled from "styled-components";
import { _dynamic_tab_head } from ".";

export default function TableHeader() {
    return (
        <TableStyle>
            <TableHead>
                <Tr>
                    {_dynamic_tab_head.items.map((head, index) => {
                        return (
                            <TableCell
                                style={head.style}
                                key={index}
                                FontWeight="600"
                            >
                                {head.content}
                            </TableCell>
                        );
                    })}
                </Tr>
            </TableHead>
        </TableStyle>
    );
}

const TableCell = styled.td`
    width: 245px;

    padding: 16px;
    border-bottom: 1px solid #ddd;
    vertical-align: middle;
    text-align: center;
    color: #424242;
    font-size: 18px;
    font-style: normal;
    font-weight: ${({ FontWeight }) => (FontWeight ? FontWeight : "400")};
    line-height: 24px;
`;

const Tr = styled.tr`
    border-radius: 14px;
`;

const TableHead = styled.thead`
    width: 150px;
    text-align: left;
    background-color: #f5f5f5;
    border-bottom: 1px solid #ddd;
    border-radius: 24px;
`;

const TableStyle = styled.table`
    width: 100%;
    height: 100%;
    position: sticky;
    top: 0;
    border-collapse: collapse;
    margin: 0 auto;
`;
